import { render, staticRenderFns } from "./MyColumnsDropdown.vue?vue&type=template&id=efe37be4&scoped=true"
import script from "./MyColumnsDropdown.vue?vue&type=script&lang=js"
export * from "./MyColumnsDropdown.vue?vue&type=script&lang=js"
import style0 from "./MyColumnsDropdown.vue?vue&type=style&index=0&id=efe37be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe37be4",
  null
  
)

export default component.exports